import {FC} from "react";

export const Footer: FC = () => {
   return <>
    </>
}